<div class="application-version">
	<div>{{webAppInfo | versionInfo: 'Web application: '}}</div>
	<div>{{serverInfo$ | async | versionInfo: 'Server: '}}</div>
</div>
